var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 31,
    height: 25,
    transform: "translate(-699 2290)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_85",
    "data-name": "Mask Group 85",
    transform: "translate(699 -2290)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(-699 2290.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517",
    transform: "translate(0 10.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M26.839,72.589H23.761a5,5,0,0,0-1.211.149,4.673,4.673,0,0,0-4.107-2.309H13A4.673,4.673,0,0,0,8.9,72.737a5,5,0,0,0-1.21-.148H4.607A4.427,4.427,0,0,0,0,76.8v4.5a2.656,2.656,0,0,0,2.764,2.526H28.682A2.656,2.656,0,0,0,31.446,81.3V76.8A4.427,4.427,0,0,0,26.839,72.589ZM8.4,74.641v7.5H2.764a.886.886,0,0,1-.921-.842V76.8a2.656,2.656,0,0,1,2.764-2.526H7.684a3,3,0,0,1,.722.088C8.4,74.453,8.4,74.546,8.4,74.641Zm12.811,7.5H10.238v-7.5A2.656,2.656,0,0,1,13,72.115h5.441a2.656,2.656,0,0,1,2.764,2.526Zm8.4-.842a.886.886,0,0,1-.921.842H23.05v-7.5c0-.094,0-.186-.011-.278a3,3,0,0,1,.722-.088h3.078A2.656,2.656,0,0,1,29.6,76.8Z",
    transform: "translate(0 -70.428)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519",
    transform: "translate(2.052 4.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M14.339,38.791a3.757,3.757,0,1,0,0,7.484,3.757,3.757,0,1,0,0-7.484Zm0,5.8a2.066,2.066,0,1,1,0-4.115,2.066,2.066,0,1,1,0,4.115Z",
    transform: "translate(-10.246 -38.791)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521",
    transform: "translate(10.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M56.665,13.409a5.256,5.256,0,0,0-5.468,5,5.49,5.49,0,0,0,10.937,0A5.255,5.255,0,0,0,56.665,13.409Zm0,8.314a3.485,3.485,0,0,1-3.626-3.315,3.641,3.641,0,0,1,7.252,0A3.485,3.485,0,0,1,56.665,21.723Z",
    transform: "translate(-51.197 -13.409)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523",
    transform: "translate(21.207 4.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M109.974,38.791a3.757,3.757,0,1,0,4.093,3.742A3.934,3.934,0,0,0,109.974,38.791Zm0,5.8a2.066,2.066,0,1,1,2.251-2.057,2.165,2.165,0,0,1-2.251,2.058Z",
    transform: "translate(-105.881 -38.791)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/Members.79a1c3d1d1973732142757e49f6260b7.svg";
export { ForwardRef as ReactComponent };